export const USER_LOGIN_COOKIE = "loginUserRemember";
export const RESET_PRODUCT_VIEWS = "resetProductViews";
export const USER_JUST_LOGGED_IN = "userJustLoggedIn";
export const USER_JUST_LOGGED_OUT = "userJustLoggedOut";
export const BASE_URL_WEB_APP =
  process.env.REACT_APP_WEB_BASE_URL || "http://138.68.242.123";

// HTTPS localhost must call its own origin; CRA forwards /app/api to staging.
// HTTPS staging uses its Nginx proxy; retain the existing fallback for older builds.
export const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? ""
    : process.env.REACT_APP_API_BASE_URL || "http://138.68.242.123:3002";
